export default __webpack_public_path__ + "static/media/5-2.3fefc12a.webp";